import disableDefaultFormSubmission from './disableDefaultFormSubmission';
import extractElementsFromPopupContent from './extractElementsFromPopupContent';
import headerFooterShouldBeOverhauled from './headerFooterShouldBeOverhauled';

const fetchPopupContent = (fileName) => {
  let url = fileName;
  if (!url.includes('?')) {
    url += '?';
  }
  url += '&without_iframe';

  return fetch(url)
    .then(
      (response) =>
        new Promise((resolve) =>
          response.text().then((text) => resolve({ content: text, redirected: response.redirected })),
        ),
    )
    .then((response) => {
      const error = getErrorMessage(response.content);

      if (response.redirected && error !== '') {
        return `<h1></h1><div class="popup-fetch-error"><p>${error}</p></div>`;
      }

      return response.content;
    })
    .then((body) => {
      const { content, scripts } = extractElementsFromPopupContent(body);

      const popupOverhaulEnabled = headerFooterShouldBeOverhauled(fileName);

      return {
        content: `<div class="popup-without-iframe${popupOverhaulEnabled ? ' popup-overhaul' : ''}">${content}</div>`,
        afterRenderCallback: () => {
          window.TL.DatePicker.init();
          window.TL.TimePicker.init();
          window.TL.Documentlines.init();
          disableDefaultFormSubmission(false);

          scripts.forEach((script) => {
            try {
              eval(script.innerText); // eslint-disable-line no-eval
            } catch (error) {
              // eslint-disable-next-line no-console
              console.error(error);
            }
          });
          document.dispatchEvent(new CustomEvent('popup.loaded', { detail: fileName }));
        },
      };
    });
};

const getErrorMessage = (content) => {
  const startString = "TL.Toast.launch('";
  const endString = "', 'error')";
  const start = content.indexOf(startString);
  const end = content.indexOf(endString, start);

  return content.substr(start + startString.length, end - (start + startString.length));
};

export default fetchPopupContent;
